import { z } from 'zod'

export const CustomerVendorsSchema = z.object({
  historyPage: z.number().int().nonnegative().optional(),
  historySize: z.number().int().nonnegative().optional()
})
